import React from "react";
import A from "../components/A";
import { ReactComponent as DiscordSvg } from "../assets/svg/discord.svg";
import { ReactComponent as TgSvg } from "../assets/svg/tg.svg";
import { ReactComponent as YoutubeSvg } from "../assets/svg/youtube.svg";

const MegalodonLinks = ({ size }) => {
  return (
    <div className={`megalodon-links ${size ? size : ""}`}>
      <A href="https://discord.gg/megalodon">
        <DiscordSvg />
      </A>
      <A href="https://t.me/Theislemegalodon">
        <TgSvg />
      </A>
      <A href="#">
        <YoutubeSvg />
      </A>
    </div>
  );
};

export default MegalodonLinks;
